// extracted by mini-css-extract-plugin
export default {"hyphenate":"hyphenate___1s086"};